import {
    Text,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from '@chakra-ui/react';
import { useDeleteClientSingleAliasMutation } from 'core/API/productsApi';
import { useTranslation } from 'helpers/languages/translations';
import { TAliasProps } from '../../AliasContainer';

const AliasDeleteModal = ({ currentAlias, isOpenDelete, onCloseDelete }: TAliasProps) => {
    const translate = useTranslation();
    const toast = useToast();

    const [deleteAlias, { isLoading: isDeleteLoading }] = useDeleteClientSingleAliasMutation();

    const handleDeleteAlias = async () => {
        try {
            const res = await deleteAlias({ key: currentAlias!.mainAlias });

            if ('error' in res) throw new Error(translate('alias.delete.error') as string);

            onCloseDelete();
            toast({
                title: translate('alias.delete.success'),
                status: 'success',
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: (error as Error).message,
                status: 'error',
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpenDelete} onClose={onCloseDelete}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text as="h3">{translate('alias.delete')}</Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isDeleteLoading} />
                <ModalBody fontSize="sm">
                    {translate('alias.delete.confirmation', {
                        name: (
                            <Text mx={1} as="span" fontWeight="bold">
                                {currentAlias?.mainAlias}
                            </Text>
                        ),
                    })}
                </ModalBody>
                <ModalFooter>
                    <Button isDisabled={isDeleteLoading} variant="outline" size="sm" mr={3} onClick={onCloseDelete}>
                        {translate('alias.update.cancel')}
                    </Button>
                    <Button onClick={handleDeleteAlias} isLoading={isDeleteLoading} colorScheme="red" size="sm">
                        {translate('alias.delete.apply')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AliasDeleteModal;
